import React from "react";
import AuthContainer from "../authentication/AuthContainer";
import AuthHeader from "../authentication/AuthHeader";
import AuthFooter from "../authentication/AuthFooter";
import RegistrationForm from "../authentication/RegistrationForm";
import SignUpLogo from "../../asset/signup.png";
import { Fade, Grid, useMediaQuery, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";

const SignUp = () => {
  const matches = useMediaQuery("(min-width:900px)");
  const theme = useTheme();

  return (
    <Fade in>
      <Grid
        container
        justifyContent="center"
        style={{ position: "relative", textAlign: "center" }}
      >
        <Grid item xs={12} sm={6} md={7} style={{ display: "block" }}>
          <img
            src={SignUpLogo}
            alt="Sign Up"
            style={{
              width: "100%",
              maxWidth: "600px",
              display: "block",
              margin: "auto",
              marginTop: matches ? "180px" : "0",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{
            margin: matches ? "-20px 0 0 0" : "0 0 20px 0",
            order: matches ? "2" : "1",
          }}
        >
          <AuthContainer>
            <AuthHeader header="Join Us!" />
            <Typography color="textSecondary">
              Start a free trial today for 30 days
            </Typography>
            <RegistrationForm />
            <AuthFooter
              para="Already have an account? "
              to="/sign-in"
              navText="Sign in"
            />
            <Typography variant="body2" color="textSecondary" align="center">
              {"By creating a ACC Copilot account, you agree to our "}
              <Link
                to="/terms-and-conditions"
                style={{
                  fontWeight: "bold",
                  color: `${theme.palette.primary.main}`,
                  textDecoration: "none",
                }}
              >
                Terms of Service
              </Link>
              {" and "}
              <Link
                to="/privacy-policy"
                style={{
                  fontWeight: "bold",
                  color: `${theme.palette.primary.main}`,
                  textDecoration: "none",
                }}
              >
                Privacy Policy
              </Link>
            </Typography>
          </AuthContainer>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default SignUp;
